"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.datasetOpTypes = exports.datapointStatuses = void 0;
exports.datapointStatuses = ['ACTIVE', 'MANUALLY_EXPIRED'];
exports.datasetOpTypes = ['IMPORT', 'EXPORT', 'SUBSCRIBE'];
//# sourceMappingURL=Datasets.js.map